// Node（テスト）は JSON の読み込みに種類の明示を求める。Vite と TypeScript も同じ書き方を受ける
import account from "../paths/account.json" with { type: "json" };
import adminCenter from "../paths/admin-center.json" with { type: "json" };
import estimates from "../paths/estimates.json" with { type: "json" };
import invoices from "../paths/invoices.json" with { type: "json" };
import tenantUsers from "../paths/tenant-users.json" with { type: "json" };
import tenants from "../paths/tenants.json" with { type: "json" };

/**
 * 会員の画面（React）が受け持つ URL（docs/04 §5.2.1）。
 *
 * <b>画面のまとまりごとに 1 ファイル</b>（<c>paths/*.json</c>）。まとまりごとのルート
 * （<c>areas/(まとまり)/routes.tsx</c>）と対で、テストが突き合わせる。
 * 静的サイトの書き出しも同じファイルを読む。
 */
interface AreaPaths {
    readonly prefixes: readonly string[];
    readonly pages: readonly string[];
}

const areas: readonly AreaPaths[] = [account, tenants, tenantUsers, invoices, adminCenter, estimates];

export const memberPaths: AreaPaths = {
    prefixes: areas.flatMap((o) => o.prefixes),
    pages: areas.flatMap((o) => o.pages),
};
